export default function NeonMic({ className }) {
    return (
        <svg
            viewBox="0 0 320 400"
            fill="none"
            aria-hidden="true"
            className={className}
            style={{
                filter:
                    "drop-shadow(0 0 6px rgba(255,0,127,0.75)) drop-shadow(0 0 24px rgba(255,0,127,0.35))",
            }}
        >
            <defs>
                <linearGradient id="nm-g" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#FF007F" />
                    <stop offset="1" stopColor="#C084FC" />
                </linearGradient>
            </defs>

            {/* check-in ring */}
            <circle
                cx="160"
                cy="140"
                r="96"
                stroke="#8B5CF6"
                strokeWidth="1.5"
                strokeDasharray="6 10"
                opacity="0.8"
            />
            <circle
                cx="160"
                cy="140"
                r="76"
                stroke="url(#nm-g)"
                strokeWidth="1.2"
                opacity="0.5"
            />

            {/* mic head */}
            <rect
                x="122"
                y="66"
                width="76"
                height="118"
                rx="38"
                stroke="url(#nm-g)"
                strokeWidth="4"
            />
            <line x1="136" y1="102" x2="184" y2="102" stroke="#FF4D9D" strokeWidth="2" strokeLinecap="round" />
            <line x1="132" y1="122" x2="188" y2="122" stroke="#FF4D9D" strokeWidth="2" strokeLinecap="round" />
            <line x1="136" y1="142" x2="184" y2="142" stroke="#FF4D9D" strokeWidth="2" strokeLinecap="round" />
            <line x1="142" y1="160" x2="178" y2="160" stroke="#FF4D9D" strokeWidth="2" strokeLinecap="round" />

            {/* stem + base */}
            <line x1="160" y1="184" x2="160" y2="300" stroke="url(#nm-g)" strokeWidth="4" strokeLinecap="round" />
            <path
                d="M112 306c10 18 27 30 48 30s38-12 48-30"
                stroke="url(#nm-g)"
                strokeWidth="4"
                strokeLinecap="round"
            />
            <line x1="160" y1="336" x2="160" y2="356" stroke="url(#nm-g)" strokeWidth="4" strokeLinecap="round" />
            <line x1="128" y1="360" x2="192" y2="360" stroke="url(#nm-g)" strokeWidth="4" strokeLinecap="round" />

            {/* sparkles */}
            <path d="M64 60c1.6 12 8 18.4 20 20-12 1.6-18.4 8-20 20-1.6-12-8-18.4-20-20 12-1.6 18.4-8 20-20z" fill="#FF007F" opacity="0.9" />
            <path d="M258 108c1.2 9 6 13.8 15 15-9 1.2-13.8 6-15 15-1.2-9-6-13.8-15-15 9-1.2 13.8-6 15-15z" fill="#C084FC" opacity="0.8" />
            <path d="M56 250c1.2 9 6 13.8 15 15-9 1.2-13.8 6-15 15-1.2-9-6-13.8-15-15 9-1.2 13.8-6 15-15z" fill="#8B5CF6" opacity="0.7" />
        </svg>
    );
}
